/**
 * Lo último que cada persona vio en el centro de incidentes: la base de la «bola
 * roja». Se guarda en el navegador (localStorage), por usuario: es una notificación
 * personal, no un dato de la cuenta. Si la misma persona entra desde otro navegador o
 * equipo, ahí la bola vuelve a aparecer.
 *
 * Todo es tolerante a fallos: con el almacenamiento bloqueado (modo privado, políticas
 * del navegador) no se rompe nada; simplemente todo cuenta como nuevo.
 */

export const SEEN_KEY_PREFIX = 'nua.incidents.lastSeen.';
/** Aviso dentro de la misma pestaña (el evento `storage` solo llega a las OTRAS). */
export const SEEN_EVENT = 'nua:incidents-seen';

const keyFor = (userSub) => `${SEEN_KEY_PREFIX}${String(userSub || 'anon')}`;

export const getLastSeen = (userSub) => {
  try {
    const value = window.localStorage.getItem(keyFor(userSub));
    return value && !Number.isNaN(Date.parse(value)) ? value : null;
  } catch {
    return null;
  }
};

/**
 * Guarda `iso` como lo último visto, sin retroceder: solo cambia si es más reciente que
 * lo ya guardado. Devuelve el valor que queda.
 */
export const markSeen = (userSub, iso) => {
  const next = Date.parse(iso || '');
  if (Number.isNaN(next)) return getLastSeen(userSub);
  const previous = getLastSeen(userSub);
  if (previous && Date.parse(previous) >= next) return previous;
  const value = new Date(next).toISOString();
  try {
    window.localStorage.setItem(keyFor(userSub), value);
  } catch {
    // sin almacenamiento: la bola no se apaga, pero nada se rompe
  }
  try {
    window.dispatchEvent(new CustomEvent(SEEN_EVENT, { detail: { userSub, value } }));
  } catch {
    // entornos sin CustomEvent
  }
  return value;
};
